import ModalDialog, { ModalBody } from 'components/ui/ModalDialog'
import Page from './NewTemplate'

const Dialog = () => {
  return (<ModalDialog shouldScrollInViewport={true} autoFocus={false}>
    <ModalBody>
      <Page />
    </ModalBody>
  </ModalDialog>)
}

export default Dialog
